import React, { useState, useCallback } from 'react';
import { ChevronDown } from 'lucide-react';

const ContentTypeDropdown = ({ seriesData, themes, onSelectOption }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDropdownOpen(prevState => !prevState);
    }, []);

    const selectOption = useCallback((option) => {
        onSelectOption(option);
        setIsDropdownOpen(false);
    }, [onSelectOption]);

    return (
        <div className="relative">
            <button
                onClick={toggleDropdown}
                className="w-full p-2 border border-gray-300 rounded-lg bg-white text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            >
                <span>{seriesData.contentType || "Select a content type"}</span>
                <ChevronDown className={`w-5 h-5 transition-transform duration-200 ${isDropdownOpen ? 'transform rotate-180' : ''}`} />
            </button>
            {isDropdownOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                    {themes.map((theme) => (
                        <button
                            key={theme._id}
                            onClick={() => selectOption(theme.theme)}
                            className="w-full p-2 text-left hover:bg-indigo-100 transition-colors duration-200"
                        >
                            {theme.theme}
                        </button>
                    ))}
                    <button
                        onClick={() => selectOption("Custom Topic")}
                        className="w-full p-2 text-left hover:bg-indigo-100 transition-colors duration-200"
                    >
                        Enter YOUR own custom genre
                    </button>
                </div>
            )}
        </div>
    );
};

export default ContentTypeDropdown
